import React, { useContext, useState, useEffect, useCallback } from "react";
import Loader from "../components/common/Loader";
import { Grid, Button, Box, Typography } from "@mui/material";
import { useStripeConnect } from "../hooks/useStripeConnect";
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import {
  createStripeAccount,
  getStripeAccountLoginLink,
  getStripeAccount,
} from "../api";
import UserContext from "../contexts/UserContext";
import StripeOnboardingInfo from "../components/StripeOnboardingInfo";
// import {
//   ONGOING_ONBOARDING_STATUS,
//   ONGOING_ONBOARDING_STATUS_PERSONAL_ID_REQUIRED_STATUS,
//   COMPLETED_ONBOARDING_STATUS,
// } from "../constants";

export default function PaymentsPage() {
  const [connectedAccountId, setConnectedAccountId] = useState();
  const [withdrawalDetails, setWithdrawalDetails] = useState();
  const [showCompletionMessage, setShowCompletionMessage] = useState(false);

  const stripeConnectInstance = useStripeConnect(connectedAccountId);

  const userContext = useContext(UserContext);

  const fetchAccountStatus = useCallback(async () => {
    if (userContext.user?.stripeConnectedAccountId) {
      try {
        const account = await getStripeAccount();
        if (
          account.details_submitted
          // account.charges_enabled &&
          // account.capabilities.transfers === "active" &&
          // account.payouts_enabled
          // account.requirements.currently_due.length === 0 &&
          // account.requirements.eventually_due.length === 0 &&
          // account.requirements.past_due.length === 0 &&
          // account.future_requirements.currently_due.length === 0 &&
          // account.future_requirements.eventually_due.length === 0 &&
          // account.future_requirements.past_due.length === 0
        ) {
          setShowCompletionMessage(true);
          const loginLink = await getStripeAccountLoginLink();
          setWithdrawalDetails({
            url: loginLink.url,
          });
        } else {
          setShowCompletionMessage(false);
        }
        setConnectedAccountId(userContext.user.stripeConnectedAccountId);
      } catch (error) {
        console.error("Error fetching Stripe account status:", error);
        setShowCompletionMessage(false);
      }
    }
  }, [userContext.user?.stripeConnectedAccountId]);

  useEffect(() => {
    (async () => {
      if (userContext.fetchedUser) {
        if (userContext.user?.stripeConnectedAccountId) {
          await fetchAccountStatus();
        } else {
          try {
            const { accountId } = await createStripeAccount();
            setConnectedAccountId(accountId);
            userContext.setStripeConnectedAccountId(accountId);
            setShowCompletionMessage(false);
          } catch (error) {
            console.error("Error creating Stripe account:", error);
            setShowCompletionMessage(false);
          }
        }
      }
    })();
  }, [
    userContext.fetchedUser,
    userContext.user?.stripeConnectedAccountId,
    fetchAccountStatus,
    userContext,
  ]);

  const handleDashboardClick = () =>
    window.open(withdrawalDetails.url, "_blank");

  const handleOnboardingExit = () => {
    fetchAccountStatus();
  };

  return userContext.fetchedUser ? (
    <Grid
      container
      p={4}
      spacing={4}
      sx={{
        maxWidth: "1100px",
        margin: "20px auto 0",
        width: "100%",
        boxSizing: "border-box",
        overflow: "hidden",
        "@media (max-width: 600px)": {
          padding: "16px 8px",
          marginLeft: "0",
          marginRight: "0",
        },
      }}
      justifyContent="center"
      alignItems="center"
    >
      {withdrawalDetails?.url && (
        <>
          <Grid item xs={12}>
            <StripeOnboardingInfo onboardingComplete={true} />
          </Grid>
          <Grid item xs={12} sx={{ marginBottom: "30px" }}>
            <Button
              type="submit"
              onClick={handleDashboardClick}
              variant="contained"
            >
              Go To Stripe Payments Dashboard
            </Button>
          </Grid>
        </>
      )}
      {withdrawalDetails?.url &&
        (stripeConnectInstance ||
          !userContext.user.stripeConnectedAccountId) && (
          <hr
            style={{
              width: "100%",
              height: 0,
              borderTop: 0,
              borderBottomWidth: "0.5px",
              borderBottomColor: "white",
            }}
          />
        )}
      {stripeConnectInstance ? (
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            overflow: "hidden",
          }}
        >
          {!withdrawalDetails?.url && <StripeOnboardingInfo onboardingComplete={false} />}

          <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
            <div
              style={{
                width: "100%",
                maxWidth: "100%",
                display: "flex",
                justifyContent: "center",
                overflow: "hidden",
                marginLeft: "0",
                marginRight: "0",
                padding: "0",
              }}
            >
              <ConnectAccountOnboarding
                onExit={handleOnboardingExit}
                collectionOptions={{
                  fields: "eventually_due",
                  futureRequirements: "include",
                }}
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  margin: "0 auto",
                  display: "block",
                  marginLeft: "0",
                  marginRight: "0",
                }}
              />
            </div>
          </ConnectComponentsProvider>

          {showCompletionMessage && !withdrawalDetails?.url && (
            <Box
              sx={{
                mt: 3,
                p: 2,
                textAlign: "center",
                backgroundColor: "#e8f5e9",
                borderRadius: "4px",
              }}
            >
              <Typography variant="subtitle1" sx={{ color: "#2e7d32" }}>
                Your Stripe information has been submitted successfully!
              </Typography>
              <Typography variant="body2" sx={{ color: "#2e7d32", mt: 1 }}>
                You will receive an email notification as soon as Stripe
                verifies your account. This can sometimes take a few minutes to
                a couple of business days.
              </Typography>
            </Box>
          )}
        </Grid>
      ) : (
        <>
          <Loader />
        </>
      )}
    </Grid>
  ) : null;
}
